<template>
<div class="slices-outer bg-gray-300 relative">
    <div class="slices-inner relative z-20" :class="{'pb-24': lastSlice && lastSlice.name == 'basic_content'}">
        <component v-for="slice in slices" :is="f(slice.name)" :data="slice.data"></component>
    </div>
</div>
</template>

<script>
import { computed } from 'vue';

import action_grid from './Slices/ActionGrid.vue';
import anchor_id from './Slices/AnchorId.vue';
import basic_content from './Slices/BasicContent.vue';
import big_link from './Slices/BigLink.vue';
import blahquote from './Slices/Blockquote.vue';
import breakout_feature from './Slices/BreakoutFeature.vue';
import button_row from './Slices/ButtonRow.vue';
import extra_space from './Slices/ExtraSpace.vue';
import full_width_photo from './Slices/FullWidthPhoto.vue';
import horizontal_separator from './Slices/HorizontalSeparator.vue';
import icon_link_boxes from './Slices/IconLinkBoxes.vue';
import image_slideshow from './Slices/ImageSlideshow.vue';
import intro_with_form from './Slices/IntroWithForm.vue';
import latest_news from './Slices/LatestNews.vue';
import styled_table from './Slices/StyledTable.vue';
import votervoice_embed from './Slices/VotervoiceEmbed.vue';
import youtube_video from './Slices/YoutubeVideo.vue';

export default {

    props: {
        slices: {
            default: []
        }
    },

    setup(props) {
        let lastSlice = computed(() => {
            if (!props.slices.length) {
                return null;
            }
            return props.slices[props.slices.length - 1];
        });

        const f = (name) => {
            return name === 'blockquote' ? 'blahquote' : name;
        };

        return {
            f,
            lastSlice
        }
    },
    
    components: {
        action_grid,
        anchor_id,
        basic_content,
        big_link,
        blahquote,
        breakout_feature,
        button_row,
        extra_space,
        full_width_photo,
        horizontal_separator,
        icon_link_boxes,
        image_slideshow,
        intro_with_form,
        latest_news,
        styled_table,
        votervoice_embed,
        youtube_video
    }

}
</script>